import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { addComment, modalActionComments, ticketItemData } from "../../actions";
import { connect } from "react-redux";
import { URL_API } from "../../constants";



const styles = theme => ({
    MuiDialog: {
        paperScrollPaper: {
            minWidth: '400px'
        }
    }
});

class CommentModal extends React.Component {
    state = {
        comment: ''
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.props.closeModal();
        this.setState({
            comment: ''
        })
    }


    actionComment = () => {
        const { user_id, request_id } = this.props

        const jData = {
            request: request_id,
            comment: this.state.comment,
            user: user_id
        }

        this.props.addComment(request_id, jData);
        // this.props.update();

        this.handleClose();

    }

    handleChangeText = (ev) => {
        this.setState({
            comment: ev.target.value
        })
    }

    render() {
        const validText = () => {
            if (!this.state.comment) { return true } else { return false }
        }
        return (
            <React.Fragment>
                <Dialog
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                    fullWidth
                    disableBackdropClick
                >
                    <DialogTitle id="form-dialog-title">Залишити коментар</DialogTitle>
                    <DialogContent >
                        <DialogContentText>

                        </DialogContentText>
                        <TextField
                            id="multiline-flexible"
                            label="Текст коментаря"
                            multiline
                            rowsMax="4"
                            value={this.state.comment}
                            onChange={this.handleChangeText}

                            fullWidth


                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary"> Відмінити</Button>
                        <Button disabled={validText()} color="inherit" onClick={this.actionComment}> Відправити</Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        open: state.commentModal,
        auth: state.auth,
    };
};

const mapPropsToDispath = (dispatch) => {
    return {
        closeModal: () => dispatch(modalActionComments(false)),
        addComment: (id, jData) => {
            dispatch(addComment(jData))
                .then(() => dispatch(ticketItemData(`${URL_API}/request/${id}/`)))
        }
    }
}
export default connect(mapStateToProps, mapPropsToDispath)(withStyles(styles)(CommentModal))


// WEBPACK FOOTER //
// ./src/components/NewComment/Comment.js